// in src/users.js
import React from 'react';
import {List, Datagrid, TextField, EditButton, DateField, Pagination} from 'react-admin';
import {IHashTagCategory} from '../../consts/Entities';
import {HASHTAG_CATEGORY} from '../../consts/Names';

export const HashTagCategoriesList = (props: IHashTagCategory) => {
   return (
      <List {...props} bulkActionButtons={false} title="Categories" exporter={false}  perPage={25} pagination={<Pagination rowsPerPageOptions={[25,50,100,200]}/>}>
         <Datagrid>
            <TextField source={HASHTAG_CATEGORY.id} sortable={false} />
            <TextField source={HASHTAG_CATEGORY.name}  sortable={false}/>
            <DateField source={HASHTAG_CATEGORY.created_at} label="Date of creation"/>
            <EditButton />
         </Datagrid>
      </List>
   );
};
